import { axios } from '@utilities/axios';

export default class ConsentApi {
  static getUserThirdPartyConsentElection() {
    const endpoint = `${process.env.CVNA_APP_KONG_URL}/core/consent-api/api/v2/election`;
    return axios
      .get(endpoint)
      .then(response => response.data.content.general.thirdPartyOptOut)
      .catch(error => false);
  }
}
